import React, { useEffect, useState } from 'react';
import Access from "../Components/Access";
import Navbar from "../Components/Navbar";
import NavbarAdmin from "../Components/NavbarAdmin";
import ModalUpdateUser from "../Components/ModalUpdateUser";
import { rescueHtml } from '../Components/Tools';
import Checked from '../Img/icon-checked.png';
import axios from 'axios';
import qs from 'qs';
import {NotificationManager} from 'react-notifications';


const Utilisateurs = (props) =>
{
    const [aff, setAff] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [userFocus, setUserFocus] = useState(false);
    const [boolID, setBoolID] = useState(true);
    const [boolNom, setBoolNom] = useState(false);
    const [boolPrenom, setBoolPrenom] = useState(false);
    const [boolEmail, setBoolEmail] = useState(false);
    const [boolId_organisme, setBoolId_organisme] = useState(false);
    const [boolRang, setBoolRang] = useState(false);
    const [boolCreated, setBoolCreated] = useState(false);
    const [boolCertified, setBoolCertified] = useState(false);
    const [liste, setListe] = useState([]);
    const [organismes, setOrganismes] = useState([]);
    const [filtre_organisme, setFiltre_organisme] = useState('');
    const [filtre_email, setFiltre_email] = useState('');
    const [filtre_nom, setFiltre_nom] = useState('');
    const [filtre_prenom, setFiltre_prenom] = useState('');
    const heightObject = window.innerHeight/1.9;

    const purple = '#6571FE';
    const green = '#59B44A';
    const blue = '#069BD3';

    useEffect(() => {
        if (!props.user) {
            props.getUser();
        }

        axios.post("https://app-slfinance.fr/api/organismes.php", qs.stringify({'getOrganismes': true}))
        .then((res) => {
            var tmp = [];
            for (let i = 0; i < res.data.length; i++) {
                tmp[i] = {
                    id: res.data[i].id,
                    nom: rescueHtml(res.data[i].nom)
                }
            }
            setOrganismes(tmp);
        })
        .catch((err) => {
            console.warn(err);
        })

        axios.post("https://app-slfinance.fr/api/users.php", qs.stringify({'getUsers': true}))
        .then((res) => {
            setListe(res.data);
        })
        .catch((err) => {
            console.warn(err);
        })
    }, [props.user])


    function compareIdAsc(a, b)
    {
        return a.id - b.id;
    }

    function compareIdDes(a, b)
    {
        return b.id - a.id;
    }

    function compareNomAsc(a, b)
    {
        // Convertir en majuscules pour assurer la casse
        const nomA = a.nom?a.nom.toUpperCase():0;
        const nomB = b.nom?b.nom.toUpperCase():0;
    
        if (nomA < nomB) {
            return -1;
        }
        if (nomA > nomB) {
            return 1;
        }
        return 0;
    }

    function compareNomDes(a, b)
    {
        // Convertir en majuscules pour assurer la casse
        const nomA = a.nom?a.nom.toUpperCase():0;
        const nomB = b.nom?b.nom.toUpperCase():0;
    
        if (nomA > nomB) {
            return -1;
        }
        if (nomA < nomB) {
            return 1;
        }
        return 0;
    }

    function comparePrenomAsc(a, b)
    {
        // Convertir en majuscules pour assurer la casse
        const prenomA = a.prenom?a.prenom.toUpperCase():0;
        const prenomB = b.prenom?b.prenom.toUpperCase():0;
    
        if (prenomA < prenomB) {
            return -1;
        }
        if (prenomA > prenomB) {
            return 1;
        }
        return 0;
    }

    function comparePrenomDes(a, b)
    {
        // Convertir en majuscules pour assurer la casse
        const prenomA = a.prenom?a.prenom.toUpperCase():0;
        const prenomB = b.prenom?b.prenom.toUpperCase():0;
    
        if (prenomA > prenomB) {
            return -1;
        }
        if (prenomA < prenomB) {
            return 1;
        }
        return 0;
    }

    function compareEmailAsc(a, b)
    {
        // Convertir en majuscules pour assurer la casse
        const emailA = a.email?a.email.toUpperCase():0;
        const emailB = b.email?b.email.toUpperCase():0;
    
        if (emailA < emailB) {
            return -1;
        }
        if (emailA > emailB) {
            return 1;
        }
        return 0;
    }

    function compareEmailDes(a, b)
    {
        // Convertir en majuscules pour assurer la casse
        const emailA = a.email?a.email.toUpperCase():0;
        const emailB = b.email?b.email.toUpperCase():0;
    
        if (emailA > emailB) {
            return -1;
        }
        if (emailA < emailB) {
            return 1;
        }
        return 0;
    }

    function compareId_organismeAsc(a, b)
    {
        return a.id_organisme - b.id_organisme;
    }

    function compareId_organismeDes(a, b)
    {
        return b.id_organisme - a.id_organisme;
    }

    function compareRangAsc(a, b)
    {
        return a.id_type_users - b.id_type_users;
    }

    function compareRangDes(a, b)
    {
        return b.id_type_users - a.id_type_users;
    }

    function compareCreatedAsc(a, b)
    {
        const dateA = new Date(a.created);
        const dateB = new Date(b.created);
        return dateA - dateB;
    }

    function compareCreatedDes(a, b)
    {
        const dateA = new Date(a.created);
        const dateB = new Date(b.created);
        return dateB - dateA;
    }

    function compareCertifiedAsc(a, b)
    {
        if (a.token && !b.token) {
            return 1;
        }
        if (!a.token && b.token) {
            return -1;
        }
        return 0;
    }

    function compareCertifiedDes(a, b)
    {
        if (a.token && !b.token) {
            return -1;
        }
        if (!a.token && b.token) {
            return 1;
        }
        return 0;
    }

    function getDroits(id_user)
    {
        var params = {
            'getDroits': true,
            'id_user': id_user
        }
        return axios.post('https://app-slfinance.fr/api/droits.php', qs.stringify(params))
        .then((res) => {
            if (res.data['status'] === 1) {
                return (res.data.droits);
            }
            else {
                return [];
            }
        })
        .catch((err) => {
            console.warn(err);
            return [];
        });
    }

	return (
        <Access needConnection={true} type_user={[1]}>
            <Navbar />
            <NavbarAdmin />
            <ModalUpdateUser
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            user={userFocus}
            who={props.user?props.user.id:null}
            />

            <div style={{display: 'flex', margin: 25, alignItems: 'center', gap: 10}}>
                <p>Gestion \</p>
                <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Utilisateurs</p>
                <div style={{display: 'flex', marginLeft: 100, alignItems: 'center', gap: 10}}>
                    <input 
                        className='shadow-md' 
                        type='text' 
                        placeholder='Filtrer par organisme' 
                        style={{padding: 5, width: 200}} 
                        value={filtre_organisme}
                        onChange={(e) => {setFiltre_organisme(e.target.value.toLowerCase())}}
                    />
                    <input 
                        className='shadow-md' 
                        type='text' 
                        placeholder='Filtrer par email' 
                        style={{padding: 5, width: 200}} 
                        value={filtre_email}
                        onChange={(e) => {setFiltre_email(e.target.value.toLowerCase())}}
                    />
                    <input 
                        className='shadow-md' 
                        type='text' 
                        placeholder='Filtrer par nom' 
                        style={{padding: 5, width: 200}} 
                        value={filtre_nom}
                        onChange={(e) => {setFiltre_nom(e.target.value.toLowerCase())}}
                    />
                    <input 
                        className='shadow-md' 
                        type='text' 
                        placeholder='Filtrer par prenom' 
                        style={{padding: 5, width: 200}} 
                        value={filtre_prenom}
                        onChange={(e) => {setFiltre_prenom(e.target.value.toLowerCase())}}
                    />
                </div>
            </div>


            <div className='shadow-md rounded-md' style={{margin: 50}}>
                <div style={{overflowY: 'scroll'}}>
                    <div style={{display: 'flex', backgroundColor: blue, borderTopLeftRadius: 5, borderTopRightRadius: 5, color: 'white'}}>
                        
                        <button
                        style={{flex: 0.1, alignItems: 'center', justifyContent: 'center', display: 'flex'}}>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolID) {
                                await liste.sort(compareIdDes);
                            }
                            else {
                                await liste.sort(compareIdAsc);
                            }
                            await setBoolID(!boolID);
                            await setAff(!aff);

                        }}
                        style={{flex: 0.2, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Id</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolNom) {
                                await liste.sort(compareNomDes);
                            }
                            else {
                                await liste.sort(compareNomAsc);
                            }
                            await setBoolNom(!boolNom);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.5, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Nom</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolPrenom) {
                                await liste.sort(comparePrenomDes);
                            }
                            else {
                                await liste.sort(comparePrenomAsc);
                            }
                            await setBoolPrenom(!boolPrenom);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.5, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Prenom</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolEmail) {
                                await liste.sort(compareEmailDes);
                            }
                            else {
                                await liste.sort(compareEmailAsc);
                            }
                            await setBoolEmail(!boolEmail);
                            await setAff(!aff);
                        }}
                        style={{flex: 1, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Email</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolId_organisme) {
                                await liste.sort(compareId_organismeDes);
                            }
                            else {
                                await liste.sort(compareId_organismeAsc);
                            }
                            await setBoolId_organisme(!boolId_organisme);
                            await setAff(!aff);
                        }}
                        style={{flex: 1, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Id organisme</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolRang) {
                                await liste.sort(compareRangDes);
                            }
                            else {
                                await liste.sort(compareRangAsc);
                            }
                            await setBoolRang(!boolRang);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.2, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Rang</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolCreated) {
                                await liste.sort(compareCreatedDes);
                            }
                            else {
                                await liste.sort(compareCreatedAsc);
                            }
                            await setBoolCreated(!boolCreated);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.4, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Créé le</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolCertified) {
                                await liste.sort(compareCertifiedDes);
                            }
                            else {
                                await liste.sort(compareCertifiedAsc);
                            }
                            await setBoolCertified(!boolCertified);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.2, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Certifié</p>
                        </button>
                    
                    </div>
                </div>

                <div style={{overflowY: 'scroll', maxHeight: heightObject}}>
                    {liste.map((user, i) =>
                    (filtre_organisme === '' || (user.organisme_nom && user.organisme_nom.toLowerCase().includes(filtre_organisme))) &&
                    (filtre_email === '' || (user.email && user.email.toLowerCase().includes(filtre_email))) &&
                    (filtre_nom === '' || (user.nom && user.nom.toLowerCase().includes(filtre_nom))) &&
                    (filtre_prenom === '' || (user.prenom && user.prenom.toLowerCase().includes(filtre_prenom)))?
                    <div key={i} style={{display: 'flex'}}>
                        <button style={{flex: 1, display: 'flex', borderBottom: '1px solid '+blue}}
                        onClick={async () => {
                            if (user.id) {
                                await getDroits(user.id)
                                .then(async (r) => {
                                    user.droits = r;
                                    await setUserFocus(user);
                                    await setModalVisible(true);
                                })
                            }
                        }}
                        >
                            <div style={{display: 'flex', flex: 0.1, justifyContent: 'center', alignItems: 'center'}}>
                                <div style={user.session_token?{display: 'flex', width: 15, height: 15, backgroundColor: green, borderRadius: '50%', margin: 4}:{display: 'flex', width: 15, height: 15, border: '1px solid '+blue, borderRadius: '50%', margin: 4}}>
                                </div>
                            </div>
                            <div style={{flex: 0.2, textAlign: 'center', borderLeft: '1px solid '+blue}}>
                                <p>{user.id}</p>
                            </div>
                            <div style={{display: 'flex', flex: 0.5, borderLeft: '1px solid '+blue, overflowX: 'hidden'}}>
                                <p style={{marginLeft: 5}}>{user.nom?rescueHtml(user.nom):'.'}</p>
                            </div>
                            <div style={{display: 'flex', flex: 0.5, borderLeft: '1px solid '+blue, overflowX: 'hidden'}}>
                                <p style={{marginLeft: 5}}>{user.prenom?rescueHtml(user.prenom):'.'}</p>
                            </div>
                            <div style={{display: 'flex', flex: 1, borderLeft: '1px solid '+blue, overflowX: 'hidden'}}>
                                <p style={{marginLeft: 5}}>{user.email?rescueHtml(user.email):'.'}</p>
                            </div>
                            <div style={{display: 'flex', flex: 1, borderLeft: '1px solid '+blue, overflowX: 'hidden'}}>
                                <p style={{marginLeft: 5}}>[ {user.id_organisme} ] {user.organisme_nom?rescueHtml(user.organisme_nom):'.'}</p>
                            </div>
                            <div style={{flex: 0.2, borderLeft: '1px solid '+blue, textAlign: 'center', overflowX: 'hidden'}}>
                                <p>{user.id_type_users === '1'?'SL':user.id_type_users === '2'?'Admin':user.id_type_users === '3'?'User':'.'}</p>
                            </div>
                            <div style={{flex: 0.4, borderLeft: '1px solid '+blue, borderRight: '1px solid '+blue, textAlign: 'center', overflowX: 'hidden'}}>
                                <p>{user.created?user.created.split('-')[2]+'/'+user.created.split('-')[1]+'/'+user.created.split('-')[0]:'.'}</p>
                            </div>
                            <div style={{flex: 0.2, borderRight: '1px solid '+blue, textAlign: 'center'}}>
                                {user.token?'.':
                                <div style={{display: 'flex'}}>
                                    <div style={{flex: 1}}></div>
                                    <img style={{width: 15, margin: 5}} src={Checked} />
                                    <div style={{flex: 1}}></div>
                                </div>
                                }
                            </div>
                        </button>
                    </div>
                    :null)}

                </div>

            </div>

        </Access>
	);
}


export default Utilisateurs;
